import { MedicareApiPlan } from 'types/api';
import { useSaveToggle } from 'hooks/useSaveToggle';
import { usePlanInteractionState } from 'hooks/usePlanInteractionState';
import StarRating from '../recommendation/StarRating';
import SaveButton from './SaveButton';
import styles from '../PlanCard.module.scss';

interface PlanHeaderProps {
  plan: MedicareApiPlan;
}

export default function PlanHeader({ plan }: PlanHeaderProps) {
  const isNotGap = plan.type !== 'gap';
  const { isSaved, isRecommended } = usePlanInteractionState(plan);
  const { toggle: handleSaveToggle, isPending } = useSaveToggle(plan);

  return (
    <div className={styles.planHeader}>
      <div className={styles.planInfo}>
        <h3 className={styles.planName}>{plan.name}</h3>
        {isNotGap && (
          <p className={styles.planId}>
            <b>Plan ID:</b> {plan.medicare_id}
          </p>
        )}
        <p className={styles.planCarrier}>
          <b>Carrier:</b> {plan.carrier}
        </p>
        {isNotGap && <StarRating rating={plan.star_ratings.overall} />}
      </div>
      <SaveButton
        planId={plan.id}
        isSaved={isSaved}
        onToggle={handleSaveToggle}
        lockAfterSave={isRecommended}
        isRecommended={isRecommended}
        isPending={isPending}
      />
    </div>
  );
}
